import React from "react";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import AnimationGallery from "../components/Gallery/AnimationGallery";
import CarouselGallery from "../components/Gallery/CarouselGallery";
import UseInView from "../components/Generic/UseInView";

const Gallery = () => {
  const seoData = {
    title: "WiSE Gallery — Moments, Events & Community Highlights",
    description:
      "Browse WiSE’s gallery of photos and moments—captured at events, workshops, meetups and community gatherings—showcasing our diverse, vibrant women in semiconductor community in action.",
    keywords:
      "WiSE gallery, women in semiconductor photos, event gallery women in tech, semiconductor community images, WiSE community highlights, women in STEM gallery, event snapshots WiSE",
    pathSlug: "gallery",
  };

  const [ref, inView] = UseInView();

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <div className="p-2">
        <AnimationGallery />
        {/* Lazy-load CarouselGallery only when in viewport */}
        <div ref={ref}>
          {inView ? (
            <CarouselGallery />
          ) : (
            <div className="text-center py-5">Loading gallery...</div>
          )}
        </div>
      </div>
    </>
  );
};

export default Gallery;
